<template lang="html">
  <div>
    <b-form @submit="signup">
      <b-form-group
        id="exampleInputGroup3"
        label="Email address:"
        label-for="exampleInput1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="exampleInput2"
          v-model="email"
          type="email"
          required
          placeholder="Enter email"
        />
      </b-form-group>

      <b-form-group
        id="exampleInputGroup4"
        label="Password:"
        label-for="password_input"
        description="Passwords must be longer than 6 characters."
      >
        <b-form-input
          id="password_input2"
          v-model="password"
          type="password"
          required
          placeholder=""
        />
      </b-form-group>

      <b-form-group
        id="exampleInputGroup5"
        label="Re-enter password:"
        label-for="password_input3"
      >
        <b-form-input
          id="password_input"
          v-model="password2"
          type="password"
          required
          placeholder=""
        />
      </b-form-group>

      <p v-show="$store.state.signup_error" class="mt-5 alert alert-danger">
        Error: {{ $store.state.signup_error_message }} Please try again. If
        problems persist,
        <b-link :to="{ name: 'password_reset' }">
          go to the password reset page.
        </b-link>
      </p>

      <b-button
        type="submit"
        variant="primary"
        size="lg"
        :disabled="!password_matches"
        class="mt-3"
      >
        Sign up
      </b-button>

      <b-form-checkbox
        id="checkbox-1"
        v-model="email_status"
        name="checkbox-1"
        :value="true"
        :unchecked-value="false"
        class="mt-4"
        variant="secondary"
      >
        I'd like to receive email updates when new features launch.
      </b-form-checkbox>
    </b-form>
    <p v-show="!$route.meta.login_required" class="mt-5">
      Already have an account?
      <b-link :to="{ name: 'account' }">Go to login page.</b-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "CreateAccount",
  data() {
    return {
      email: "",
      password: "",
      password2: "",
      email_status: true
    };
  },
  computed: {
    password_matches() {
      return this.password === this.password2 && this.password.length > 5;
    }
  },
  watch: {
    email_status(value) {
      this.$store.commit("set_initial_email_preference", value);
    }
  },
  mounted() {
    this.email_status = this.$store.state.initialSignupEmailPreference;
  },
  methods: {
    signup(evt) {
      evt.preventDefault();
      console.log("signup");
      this.$store.dispatch("signup", {
        email: this.email,
        password: this.password,
        trial: true
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
